const inputSelector = '.c-pactometer__partys button';
const resetSelector = '.c-pactometer__reset';

let totalSeats = 0;
const mayoria = '<div class="c-pactometer__majority-line"></div>';

function resetChart() {
  document.querySelectorAll(`${inputSelector}.is-active`).forEach((btn) => {
    btn.classList.toggle('is-active');
  });

  document.querySelector('.ac-pactometer-seats-more').innerHTML = 0;
  document.querySelector('.ac-pactometer-seats-less').innerHTML = totalSeats;
  document.getElementById('ac-pactometer-dynamic').innerHTML = '';
  document.getElementById('ac-pactometer-dynamic').insertAdjacentHTML('beforeend', mayoria);
  document.querySelector('.ac-pactometer-info-text').classList.remove('c-pactometer__info-text--green');
}

function drawChart(event) {
  let data = [];
  event.currentTarget.classList.toggle('is-active');

  document.querySelectorAll(`${inputSelector}.is-active`).forEach((btn) => {
    data.push({
      code: btn.dataset.name,
      seats: parseInt(btn.dataset.seats, 10),
    });
  });

  const sumSeats = data.reduce((prev, cur) => prev + cur.seats, 0);
  const remainingSeats = totalSeats - sumSeats;
  data = data.sort((a, b) => b.seats - a.seats);

  document.getElementById('ac-pactometer-dynamic').innerHTML = '';
  document.getElementById('ac-pactometer-dynamic').insertAdjacentHTML('beforeend', mayoria);
  document.querySelector('.ac-pactometer-seats-more').innerHTML = sumSeats;
  document.querySelector('.ac-pactometer-seats-less').innerHTML = remainingSeats;

  data.forEach((elm) => {
    const width = (elm.seats * 100) / totalSeats;
    const bar = `<span class="c-pactometer__partys-line ${elm.code}" style="width:${width}%"></span>`;
    document.getElementById('ac-pactometer-dynamic').insertAdjacentHTML('beforeend', bar);
  });

  if (sumSeats >= Math.round((totalSeats + 1) / 2)) {
    document.querySelector('.ac-pactometer-info-text').classList.add('c-pactometer__info-text--green');
  } else {
    document.querySelector('.ac-pactometer-info-text').classList.remove('c-pactometer__info-text--green');
  }
}

function addEvents() {
  document.querySelectorAll(inputSelector).forEach((input) => {
    input.addEventListener('click', drawChart);
  });

  document.querySelectorAll(resetSelector).forEach((input) => {
    input.addEventListener('click', resetChart);
  });
}

function setData(data) {
  totalSeats = data.voting.seats;
  const waitingData = data.parties.every((party) => party.seats === 0);
  const parties = waitingData
    ? data.parties.slice(0, 5)
    : data.parties.filter((party) => party.seats > 0);
  const pactomerInfo = waitingData ? window.ac_labels.pactometer.waiting : window.ac_labels.pactometer.info;
  document.querySelector('.js-pactomer-info').innerHTML = `* ${pactomerInfo}`;

  document.querySelector('.ac-pactometer-seats-less').innerHTML = totalSeats;
  document.querySelector('.ac-pactometer-partys').innerHTML = '';
  if (document.querySelector('.ac-pactometer_escanios')) {
    document.querySelector('.ac-pactometer_escanios').innerHTML = totalSeats;
  }

  parties.forEach((party) => {
    const partyHtml = `<button class="c-pactometer__btn ${party.partyCode}"
      data-name="${party.partyCode}"
      data-party="${party.partyName}"
      data-seats="${party.seats}"
      title="${party.partyName}">
      <div>
        <span class="c-pactometer__name">${
  party.seats > 0 ? party.partyName : "Partido"
}</span>
        <span class="c-pactometer__number">${
  party.seats
}<span class="c-pactometer__percentage">
          ${party.votesPct}%</span></span>
      </div>
    </button>`;

    document
      .querySelector('.ac-pactometer-partys')
      .insertAdjacentHTML('beforeend', partyHtml);
  });
  addEvents();
}

function init(data) {
  if (data.voting !== undefined) {
    setData(data);
  }
}

module.exports = {
  init,
};
